import { ColumnDef } from "@tanstack/react-table"
import React from "react"
import { FormattedMessage } from "react-intl"
import { BadgeColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import Icon from "../../../../../icon/icon.component"

export default (columnDefinition: BadgeColumnDefinition): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        const value = info.getValue() as string

        if (!value) {
            return columnDefinition.dataAttributes?.defaultValue || "-"
        }

        const valueConfig = columnDefinition.dataAttributes.badgeConfigMap[value]
        const categoryValue = info.row.original[columnDefinition.dataAttributes.statusCategoryKey ?? ""]
        const categoryConfig = columnDefinition.dataAttributes.badgeConfigMap[categoryValue]
        const type = categoryConfig?.type ?? valueConfig?.type ?? "success"
        const icon = categoryConfig?.icon ?? valueConfig?.icon
        const message = valueConfig?.message ? <FormattedMessage {...valueConfig.message} /> : value

        return (
            <div className={`badge badge-${type} badge-pill text-with-icon`}>
                {icon && <Icon className='mr-1' value={icon} />}
                {message}
            </div>
        )
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/BadgeCellMapper.tsx